import axios from 'axios';
export default class PositionOfferService {
    async getPositionOfferList(data) {
        return await axios.post('api/v1/admin/position-offer/job-list', data);
    }
    // async viewPositionUserList(data) {
    //     return await axios.post(`api/v1/admin/position-offer/user-list`, data).then((res) => res).catch((error) => error);
    // }
    async viewPositionOffers(data) {
        return await axios
            .post(`api/v1/admin/position-offer/user-list`, data)
            .then((res) => res)
            .catch((error) => error);
    }
    async FirstOccupation(data) {
        return await axios
            .get('api/v1/admin/master-data/occupation-1st-level', {
                data,
            })
            .then((res) => res.data);
    }
    async SecondOccupation(occupation_first) {
        return await axios.get(`api/v1/admin/master-data/occupation-2nd-level/${occupation_first}`).then((res) => res.data);
    }
    async ThirdOccupation(occupation_second) {
        return await axios.get(`api/v1/admin/master-data/occupation-3rd-level/${occupation_second}`).then((res) => res.data);
    }

    async GetJobSeekerDetails(seeker_id) {
        return await axios.get(`api/v1/admin/position-offer/user-details/${seeker_id}`).then((res) => res.data);
    }
}
